import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function Exercise(props){
    return(
        <tr>
            <td>{props.exercise.username}</td>
            <td>{props.exercise.description}</td>
            <td>{props.exercise.duration}</td>
            <td>{props.exercise.date.substring(0,10)}</td>
            <td>
                <button className="dlt-btn" onClick={() => {props.deleteExercise(props.exercise._id)}}>Delete</button>
            </td>
        </tr>
    )
}

export default function ExercisesList(){

    const [exercises, setExercises] = useState([]);

    useEffect(()=>{
        axios.get('https://exercise-tracker5.herokuapp.com/exercises/')
            .then(res => {
                setExercises(res.data)
            })
            .catch(err => console.log(err));
    }, [exercises]);

    function deleteExercise(id){
        axios.delete('https://exercise-tracker5.herokuapp.com/exercises/'+id)
            .then(res => console.log(res.data))
        setExercises(exercises.filter((exercise)=> id != exercise._id));
    }

    function exerciseList(){
        return exercises.map((exercise) => {
            return <Exercise exercise={exercise} deleteExercise={deleteExercise} key={exercise._id} />
        })
    }

    return(
        <div className="ExercisesList">
            <h2>Logged Exercises</h2>
            <table className='table'>
                <thead>
                    <tr>
                        <th>Username</th>
                        <th>Description</th>
                        <th>Duration</th>
                        <th>Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    { exerciseList() }
                </tbody>
            </table>
        </div>
    )
}
